import { useState, useEffect, useRef } from 'react';

const useCountAnimation = (endValue, duration = 1000, startValue = 0) => {
  const [displayValue, setDisplayValue] = useState(startValue);
  const frameRef = useRef();
  const startTimeRef = useRef();
  const previousEndValue = useRef(startValue);

  useEffect(() => {
    // Only animate if the value actually changed
    if (
      endValue === previousEndValue.current ||
      endValue === null ||
      endValue === undefined
    ) {
      setDisplayValue(endValue || 0);
      return;
    }

    const animate = (timestamp) => {
      if (!startTimeRef.current) {
        startTimeRef.current = timestamp;
      }

      const progress = Math.min(
        (timestamp - startTimeRef.current) / duration,
        1
      );

      // Use easeOutQuad for smooth deceleration
      const easeOutQuad = progress * (2 - progress);

      const currentValue =
        previousEndValue.current +
        (endValue - previousEndValue.current) * easeOutQuad;
      setDisplayValue(currentValue);

      if (progress < 1) {
        frameRef.current = requestAnimationFrame(animate);
      } else {
        previousEndValue.current = endValue;
      }
    };

    frameRef.current = requestAnimationFrame(animate);
    startTimeRef.current = null;

    return () => {
      if (frameRef.current) {
        cancelAnimationFrame(frameRef.current);
      }
    };
  }, [endValue, duration]);

  return displayValue;
};

export default useCountAnimation;
